// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3LXXu","content":"GlobalSearch_content__2GsOe"};